import type { FunctionComponent } from "react";
import { Button, Loader } from "@kanda-libs/ks-design-library";
import useMarkAllAsPaidButtonProps from "components/job/JobsListPage/JobListPageActions/MarkAllAsPaidButton/useMarkAllAsPaidButtonProps";

export interface MarkAllAsPaidButtonProps {}

const MarkAllAsPaidButton: FunctionComponent<MarkAllAsPaidButtonProps> =
  function () {
    const { onClick, isSubmitting } = useMarkAllAsPaidButtonProps();

    return (
      <>
        <Button.Text
          id="staff-mark-all-as-paid"
          label="Mark all as paid"
          className="ml-4 mr-auto"
          onClick={onClick}
          disabled={isSubmitting}
        />
        <Loader isLoading={isSubmitting} />
      </>
    );
  };

export default MarkAllAsPaidButton;
